module.exports = __webpack_public_path__ + "static/img/lb-2.08b0fa6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blog/lb-2.jpg
// module id = VWPw
// module chunks = 0